import ComponentManager from '@/Management/ComponentManager';
import * as CoreFrameDTOs from "coreframetypings/dto";
import EditContext from '@/ViewModels/Contexts/EditContext';

export default class InlineEditContext extends EditContext {

    private onPropertyValueUpdatedCallback: (context: InlineEditContext, property: string) => void;
    private onAssociationUpdatedCallback: (context: InlineEditContext, relation: string) => void;

    /**
    * Der InlineContext
    */
    protected __inlineEditContext: CoreFrameDTOs.IInlineEditingContextDTO;

    public constructor(params: any) {
        super(params);

        this.__inlineEditContext = params.inlineEditContext;
        this.onPropertyValueUpdatedCallback = this.handlerOrDefault(params.onPropertyValueUpdatedCallback);
        this.onAssociationUpdatedCallback = this.handlerOrDefault(params.onAssociationUpdatedCallback);
    }

    public getInlineEditContext(): CoreFrameDTOs.IInlineEditingContextDTO {
        return this.__inlineEditContext;
    }

    /**
     * @override
     */
    public init(): void {
        super.init();

        if (this.genericObject) {
            this.genericObject.onChange((property, value) => {
                this.onPropertyValueUpdatedCallback(this, property);
            }, null, this);
        }
    }

    /**
     * @override
     */
    public notifyUpdatedAssociation(relation: string): void {
        super.notifyUpdatedAssociation(relation);

        this.onAssociationUpdatedCallback(this, relation);
    }
}

ComponentManager.setViewModel('InlineEditContext', InlineEditContext, 'RADPresentation.HTMLClient.DefaultViewExtensions');